import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ContactProvider } from "@/context/ContactContext";
import { initAnalytics, trackPageview } from "@/lib/analytics";

import Home from "@/pages/Home";
import About from "@/pages/About";
import ServiceDivision from "@/pages/ServiceDivision";
import ServiceDetail from "@/pages/ServiceDetail";
import InteriorDesign from "@/pages/InteriorDesign";
import Projects from "@/pages/Projects";
import PriceGuide from "@/pages/PriceGuide";
import Contact from "@/pages/Contact";
import Quotation from "@/pages/Quotation";
import SeoLanding from "@/pages/SeoLanding";
import { Privacy, Terms } from "@/pages/Legal";
import NotFound from "@/pages/NotFound";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import { SEO_PAGES } from "@/data/seoPages";

function RouteWatcher() {
  const location = useLocation();
  useEffect(() => {
    trackPageview(location.pathname + location.search);
  }, [location.pathname, location.search]);
  return null;
}

function App() {
  useEffect(() => { initAnalytics(); }, []);
  return (
    <div className="App">
      <AuthProvider>
        <ContactProvider>
          <BrowserRouter>
            <RouteWatcher />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services/:slug" element={<ServiceDivision />} />
              <Route path="/services/:slug/:serviceSlug" element={<ServiceDetail />} />
              <Route path="/interior-design" element={<InteriorDesign />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/price-guide" element={<PriceGuide />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/request-quotation" element={<Quotation />} />
              {SEO_PAGES.map((p) => (
                <Route key={p.slug} path={`/${p.slug}`} element={<SeoLanding slug={p.slug} />} />
              ))}
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" richColors />
        </ContactProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
